import React, { Component, Fragment } from "react";
import CheckAuth from "../../../utils/hoc/CheckAuth";
import Steps from "../../../components/molecules/Steps";
import { TipePinjaman } from "../../organism/drafPinjaman/TipePinjaman";
import { DataPinjaman } from "../../organism/drafPinjaman/DataPinjaman";
import { DataJaminan } from "../../organism/drafPinjaman/DataJaminan";
import { connect } from "react-redux";
import { PostDrafPinjaman, SubmitPinjaman } from "../../../redux/actions/DrafPinjaman";
import { asyncLoanDetail } from "../../../redux/actions/LoanDetail";
import ModalInformation from "../../organism/ModalInformation";
import RefreshToken from "../../../redux/actions/RefreshToken";
import DataPinjamanNew from "../../organism/drafPinjaman/DataPinjamanNew";
import DataDokumenNew from "../../organism/drafPinjaman/DataDokumenNew";

class DraftPinjamanDetil extends Component {
	constructor(props) {
		super(props);
		this.state = {
			steps: {
				list: ["Data Pinjaman", "Dokumen Pendukung"],
				active: 0,
			},
		};
	}

	postOrPatch = ({ data, stepChange, loanCode }) => {
		const { RefreshToken, PostDrafPinjaman } = this.props;
		console.log("data mau dikirim === ", { data });

		RefreshToken((ClientID) => {
			if (ClientID) {
				PostDrafPinjaman(ClientID, data, loanCode, (result) => {
					if (!result.isError) {
						!loanCode && this.props.history.replace(`/draf-pinjaman/edit/${result.loanCode}`);
						this.setState({
							steps: {
								...this.state.steps,
								active: stepChange,
							},
						});
					}
				});
			}
		});
	};

	submitDrafPinjaman = (cb) => {
		const { RefreshToken, SubmitPinjaman } = this.props;
		const { loanCode } = this.props.match.params;

		RefreshToken((ClientID) => {
			if (ClientID) {
				SubmitPinjaman(ClientID, loanCode, ({ isError }) => {
					if (!isError) {
						cb(true);
						this.props.history.push("/pengajuan-pinjaman");
					} else {
						cb(false);
					}
				});
			}
		});
	};

	getDisplay = (active) => {
		switch (active) {
			case 0:
				return <DataPinjamanNew {...this.props} postOrPatch={this.postOrPatch} />;
			case 1:
				return (
					<DataDokumenNew
						{...this.props}
						submitDraf={this.submitDrafPinjaman}
						goBack={() => {
							this.setState(
								{
									steps: {
										...this.state.steps,
										active: 0,
									},
								},
								() => {
									this.props.GetDetailPinjaman(this.props.ClientID, this.props.match.params.loanCode);
								}
							);
						}}
					/>
				);
			default:
				return null;
		}
	};

	componentDidMount = () => {
		const { setTitlePage, GetDetailPinjaman, ClientID } = this.props;
		const { loanCode } = this.props.match.params;

		loanCode && GetDetailPinjaman(ClientID, loanCode);
		setTitlePage({
			title: "Kelola Draf Pinjaman",
			breadcrumb: [
				{ name: "Beranda", url: "/dashboard", status: false },
				{ name: "Draf Pinjaman", url: "/draf-pinjaman", status: false },
				{ name: "Kelola Draf Pinjaman", url: "/#", status: true },
			],
		});
	};

	render() {
		const { steps } = this.state;

		return (
			<Fragment>
				<Steps onClick={() => {}} list={steps.list} active={steps.active} />

				<div className="form-wrapper">{this.getDisplay(steps.active)}</div>
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		detailPinjaman: state.loanDetailState,
		col: {
			label: "col-12 col-lg-2 col-md-3",
			text: "col-12 col-lg-10 col-md-9 mt-2 mt-md-0",
		},
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		SubmitPinjaman: (ClientID, Id, cb) => {
			//For Post or Patch Data
			dispatch(SubmitPinjaman(ClientID, Id, cb));
		},
		PostDrafPinjaman: (ClientID, data, Id, cb) => {
			//For Post or Patch Data
			dispatch(PostDrafPinjaman(ClientID, data, Id, cb));
		},
		GetDetailPinjaman: (ClientID, Id) => {
			//For Post anf Patch Data
			dispatch(asyncLoanDetail(ClientID, Id));
		},
		RefreshToken: (cb) => {
			dispatch(RefreshToken(cb));
		},
	};
};

export default CheckAuth(connect(mapStateToProps, mapDispatchToProps)(DraftPinjamanDetil));
